
// Admin
  export const ADMIN_POSITIONS_ACTIONS = {
    // list
    POSITIONS_LIST_REQUEST: "ADMIN_POSITIONS_LIST_REQUEST",
    POSITIONS_LIST_RESPONSE: "ADMIN_POSITIONS_LIST_RESPONSE",
    POSITIONS_LIST_ERROR: "ADMIN_POSITIONS_LIST_ERROR",

    // create
    POSITIONS_REQUEST: "POSITIONS_REQUEST",
    POSITIONS_RESPONSE: "POSITIONS_RESPONSE",
    POSITIONS_ERROR: "POSITIONS_ERROR",

    // update
    POSITIONS_EDIT_REQUEST: "POSITIONS_EDIT_REQUEST",
    POSITIONS_EDIT_RESPONSE: "POSITIONS_EDIT_RESPONSE",
    POSITIONS_EDIT_ERROR: "POSITIONS_EDIT_ERROR",

    // delete
    POSITIONS_DELETE_REQUEST: "POSITIONS_DELETE_REQUEST",
    POSITIONS_DELETE_RESPONSE: "POSITIONS_DELETE_RESPONSE",
    POSITIONS_DELETE_ERROR: "POSITIONS_DELETE_ERROR",
  };
  